import Icon from "@ant-design/icons";

const icon = () => (
  <svg
    height="1em"
    viewBox="0 0 512 512"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m184.175781 416.316406h143.058594v63.839844h-143.058594zm0 0"
      fill="#5a5a5a"
    />
    <path
      d="m485.15625 426.003906h-458.902344c-14.5 0-26.253906-11.753906-26.253906-26.253906v-373.496094c0-14.5 11.753906-26.253906 26.253906-26.253906h458.902344c14.5 0 26.253906 11.753906 26.253906 26.253906v373.496094c0 14.5-11.753906 26.253906-26.253906 26.253906zm0 0"
      fill="#c9f0ff"
    />
    <path
      d="m511.414062 26.257812v373.492188c0 14.5-11.753906 26.253906-26.257812 26.253906h-32.070312c14.503906 0 26.257812-11.753906 26.257812-26.253906v-373.492188c0-14.5-11.753906-26.25390575-26.257812-26.25390575h32.070312c14.503906 0 26.257812 11.75390575 26.257812 26.25390575zm0 0"
      fill="#9ae7fd"
    />
    <path
      d="m511.410156 362.75h-511.410156v37c0 14.5 11.753906 26.253906 26.253906 26.253906h458.902344c14.5 0 26.253906-11.753906 26.253906-26.253906zm0 0"
      fill="#838383"
    />
    <path
      d="m511.414062 362.75v37c0 14.5-11.753906 26.253906-26.257812 26.253906h-32.070312c14.503906 0 26.257812-11.753906 26.257812-26.253906v-37zm0 0"
      fill="#5a5a5a"
    />
    <path
      d="m511.996094 89.5625h-511.425782v-63.308594c0-14.5 11.753907-26.253906 26.25-26.253906h458.921876c14.5 0 26.25 11.753906 26.25 26.253906v63.308594zm0 0"
      fill="#acacac"
    />
    <path
      d="m512 26.25v63.316406h-32.65625v-63.316406c0-14.492188-11.753906-26.24609375-26.257812-26.24609375h32.660156c14.5 0 26.253906 11.75390575 26.253906 26.24609375zm0 0"
      fill="#9c9c9c"
    />
    <path
      d="m64.144531 44.5625c0 8.25-6.6875 14.933594-14.933593 14.933594-8.25 0-14.9375-6.683594-14.9375-14.933594 0-8.246094 6.6875-14.933594 14.9375-14.933594 8.246093 0 14.933593 6.6875 14.933593 14.933594zm0 0"
      fill="#ff5770"
    />
    <path
      d="m121.816406 44.5625c0 8.25-6.683594 14.933594-14.933594 14.933594-8.246093 0-14.933593-6.683594-14.933593-14.933594 0-8.246094 6.6875-14.933594 14.933593-14.933594 8.25 0 14.933594 6.6875 14.933594 14.933594zm0 0"
      fill="#ffd86e"
    />
    <path
      d="m179.492188 44.5625c0 8.25-6.6875 14.933594-14.933594 14.933594-8.25 0-14.933594-6.683594-14.933594-14.933594 0-8.246094 6.683594-14.933594 14.933594-14.933594 8.246094 0 14.933594 6.6875 14.933594 14.933594zm0 0"
      fill="#80e0dc"
    />
    <path
      d="m64.136719 44.566406c0 8.246094-6.679688 14.925782-14.921875 14.925782-3.996094 0-7.628906-1.566407-10.304688-4.128907 8.078125-.175781 14.585938-6.78125 14.585938-14.914062 0-4.257813-1.78125-8.089844-4.632813-10.804688.113281-.011719.238281-.011719.351563-.011719 8.242187 0 14.921875 6.679688 14.921875 14.933594zm0 0"
      fill="#ff435f"
    />
    <path
      d="m121.8125 44.566406c0 8.246094-6.679688 14.925782-14.933594 14.925782-3.992187 0-7.613281-1.566407-10.300781-4.128907 8.089844-.175781 14.59375-6.78125 14.59375-14.914062 0-4.257813-1.78125-8.089844-4.628906-10.804688.109375-.011719.222656-.011719.339843-.011719 8.253907 0 14.929688 6.679688 14.929688 14.933594zm0 0"
      fill="#ffb509"
    />
    <path
      d="m179.492188 44.566406c0 8.246094-6.691407 14.925782-14.933594 14.925782-3.996094 0-7.617188-1.566407-10.304688-4.128907 8.089844-.175781 14.585938-6.78125 14.585938-14.914062 0-4.257813-1.78125-8.089844-4.632813-10.804688.113281-.011719.238281-.011719.351563-.011719 8.242187 0 14.933594 6.679688 14.933594 14.933594zm0 0"
      fill="#00a8b0"
    />
    <path
      d="m373.59375 511.425781h-235.777344c-2.839844 0-5.144531-2.304687-5.144531-5.144531v-16.675781c0-11.308594 9.167969-20.476563 20.476563-20.476563h205.113281c11.308593 0 20.476562 9.167969 20.476562 20.476563v16.675781c0 2.839844-2.304687 5.144531-5.144531 5.144531zm0 0"
      fill="#838383"
    />
    <g fill="#5a5a5a">
      <path d="m378.738281 489.601562v16.679688c0 2.84375-2.304687 5.148438-5.148437 5.148438h-18.164063v-21.832032c0-11.300781-9.167969-20.46875-20.46875-20.46875h23.3125c11.300781 0 20.46875 9.167969 20.46875 20.472656zm0 0" />
      <path d="m54.957031 132.972656h-20.53125c-4.144531 0-7.5-3.355468-7.5-7.5 0-4.140625 3.355469-7.5 7.5-7.5h20.53125c4.140625 0 7.5 3.359375 7.5 7.5 0 4.144532-3.359375 7.5-7.5 7.5zm0 0" />
      <path d="m206.300781 132.972656h-125.265625c-4.140625 0-7.5-3.355468-7.5-7.5 0-4.140625 3.359375-7.5 7.5-7.5h125.269532c4.140624 0 7.5 3.359375 7.5 7.5-.003907 4.144532-3.359376 7.5-7.503907 7.5zm0 0" />
      <path d="m197.347656 166.9375h-50.738281c-4.144531 0-7.5-3.355469-7.5-7.5 0-4.140625 3.355469-7.5 7.5-7.5h50.738281c4.144532 0 7.5 3.359375 7.5 7.5 0 4.144531-3.355468 7.5-7.5 7.5zm0 0" />
      <path d="m121.851562 166.9375h-17.441406c-4.140625 0-7.5-3.355469-7.5-7.5 0-4.140625 3.359375-7.5 7.5-7.5h17.441406c4.144532 0 7.5 3.359375 7.5 7.5 0 4.144531-3.355468 7.5-7.5 7.5zm0 0" />
      <path d="m77.15625 166.9375h-42.730469c-4.144531 0-7.5-3.355469-7.5-7.5 0-4.140625 3.355469-7.5 7.5-7.5h42.730469c4.140625 0 7.5 3.359375 7.5 7.5 0 4.144531-3.359375 7.5-7.5 7.5zm0 0" />
    </g>
    <path
      d="m470.8125 334.40625h-66.46875v-115.605469c0-3.226562 2.617188-5.84375 5.84375-5.84375h54.78125c3.226562 0 5.84375 2.617188 5.84375 5.84375zm0 0"
      fill="#ffd86e"
    />
    <path
      d="m193.519531 334.40625h-66.464843v-74.4375c0-3.226562 2.613281-5.84375 5.84375-5.84375h54.777343c3.226563 0 5.84375 2.617188 5.84375 5.84375zm0 0"
      fill="#0396fd"
    />
    <path
      d="m285.949219 334.40625h-66.464844v-143.394531c0-3.226563 2.613281-5.84375 5.84375-5.84375h54.777344c3.226562 0 5.84375 2.617187 5.84375 5.84375zm0 0"
      fill="#80e0dc"
    />
    <path
      d="m378.378906 334.40625h-66.464844v-204.117188c0-3.226562 2.617188-5.84375 5.84375-5.84375h54.777344c3.230469 0 5.84375 2.617188 5.84375 5.84375zm0 0"
      fill="#ff5770"
    />
    <path
      d="m470.8125 334.40625h-21.878906v-121.449219h16.035156c3.226562 0 5.84375 2.617188 5.84375 5.84375zm0 0"
      fill="#ffb509"
    />
    <path
      d="m193.519531 334.40625h-21.878906v-80.28125h16.035156c3.226563 0 5.84375 2.617188 5.84375 5.84375zm0 0"
      fill="#0077f0"
    />
    <path
      d="m285.949219 334.40625h-21.878907v-149.238281h16.035157c3.226562 0 5.84375 2.617187 5.84375 5.84375zm0 0"
      fill="#00a8b0"
    />
    <path
      d="m378.378906 334.40625h-21.535156v-209.960938h15.691406c3.230469 0 5.84375 2.617188 5.84375 5.84375zm0 0"
      fill="#ff435f"
    />
    <path
      d="m470.8125 341.90625h-341.492188c-4.140624 0-7.5-3.359375-7.5-7.5 0-4.144531 3.359376-7.5 7.5-7.5h341.492188c4.140625 0 7.5 3.355469 7.5 7.5 0 4.140625-3.359375 7.5-7.5 7.5zm0 0"
      fill="#838383"
    />
  </svg>
);

const IconWebAdmin = (props) => <Icon component={icon} {...props} />;

export default IconWebAdmin;
